import { render, staticRenderFns } from "./UserCreation.vue?vue&type=template&id=612120bc&"
import script from "./UserCreation.vue?vue&type=script&lang=js&"
export * from "./UserCreation.vue?vue&type=script&lang=js&"
import style0 from "./UserCreation.vue?vue&type=style&index=0&id=612120bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports